export const LOADING_BANKSTATEMENT = "LOADING_BANKSTATEMENT";
export const POST_BANKSTATEMENT = "POST_BANKSTATEMENT";
export const GET_BANKSTATEMENT = "GET_BANKSTATEMENT";
export const GET_BANKSTATEMENT_BY_ID = "GET_BANKSTATEMENT_BY_ID";
export const UPDATE_BANKSTATEMENT = "UPDATE_BANKSTATEMENT";